// Configurações fixas do Supabase para garantir que funcionem
export const SUPABASE_CONFIG = {
  url: 'https://zjddgkcgigqywvmpbsmw.supabase.co',
  anonKey: 'sb_publishable_DYkU9y419wNSTErPoN_Qdw_3ph09j_K'
};

// Verificar se as configurações estão corretas
export const validateConfig = () => {
  const isUrlValid = SUPABASE_CONFIG.url && SUPABASE_CONFIG.url.includes('zjddgkcgigqywvmpbsmw.supabase.co');
  const isKeyValid = SUPABASE_CONFIG.anonKey && SUPABASE_CONFIG.anonKey.length > 30;
  
  console.log('🔧 Validação das configurações:', {
    url: SUPABASE_CONFIG.url,
    urlValid: isUrlValid,
    keyLength: SUPABASE_CONFIG.anonKey?.length,
    keyValid: isKeyValid
  });
  
  return isUrlValid && isKeyValid;
};

export default SUPABASE_CONFIG;